function unionPermissions(actor) {
  if (Array.isArray(actor)) return Array.from(new Set(actor));
  const roles = (actor && actor.roles) || [];
  const codes = [...((actor && actor.permissions) || [])];
  roles.forEach((role) => (role.permissions || []).forEach((permission) => codes.push(typeof permission === 'string' ? permission : permission.code)));
  return Array.from(new Set(codes.filter(Boolean)));
}

function filterMenuByPermissions(menu, permissions) {
  const set = new Set(permissions || []);
  return (menu || []).filter((item) => !item.permission || set.has(item.permission));
}

function createRouteGuard({ getToken, getPermissions, refresh }) {
  return async (to, from, next) => {
    if (to.path === '/login') return next();
    if (!getToken()) return next('/login');
    if (refresh) {
      try { await refresh(); } catch (e) { return next('/login'); }
    }
    const required = to.meta && to.meta.permission;
    if (required && !(getPermissions() || []).includes(required)) return next('/403');
    return next();
  };
}

module.exports = { unionPermissions, filterMenuByPermissions, createRouteGuard };
